import React from 'react';
import {CModalGroup, continueButtonWarn, cancelButtonLight, CancelContinueButtons} from '../..';
//@ts-ignore

const WarningModal = (props: any) => {
  const {modalProps, modalState} = props;
  const newModalProps = {...modalProps};
  newModalProps.headerColor = 'warning';
  const continueButtonProps: any = {...continueButtonWarn};
  const cancelButtonProps: any = {...cancelButtonLight};
  continueButtonProps.onClickAction = modalProps.onConfirm;
  cancelButtonProps.onClickAction = modalProps.onCancel;
  newModalProps.content.footer = <CancelContinueButtons continueButtonProps={continueButtonProps} cancelButtonProps={cancelButtonProps} />;
  return (
    <span>
      <CModalGroup modal={newModalProps} />;
    </span>
  );
};
export default WarningModal;
